import {
  ChatDocument,
  ChatQuery,
  ChatQueryVariables,
  ChatRefFragment,
  ChatRefFragmentDoc,
  withStandardRefHook,
} from '@spotify/confidence-graphql';

export const useChatRef = withStandardRefHook<
  ChatQuery,
  ChatRefFragment,
  'chat',
  ChatQueryVariables
>(ChatDocument, 'chat', ChatRefFragmentDoc, 'ChatRef', 'ConversationsV2Chat');
